export default __webpack_public_path__ + "static/media/icon_gallery.5425bb0a.svg";